import styled from 'styled-components';
import {mobileBreakPoint, FlexRow} from '../../../StyledUtils';

export const StyledSearchContainer = styled(FlexRow)`
  padding: 72px 0px; 
  width: 100%;
  align-items: center;
  justify-content: center;
  @media (max-width: ${mobileBreakPoint}) {
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #1b1b1b;
  line-height: normal;
  margin-bottom: 16px;
  text-align: center;
  @media (max-width: ${mobileBreakPoint}) {
  }
`;

export const ErrorMessage = styled.div`
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #f94338;  
  @media (max-width: ${mobileBreakPoint}) {
  }
`;
